import { render, staticRenderFns } from "./ShowTables.vue?vue&type=template&id=203f9597&scoped=true"
import script from "./ShowTables.vue?vue&type=script&lang=js"
export * from "./ShowTables.vue?vue&type=script&lang=js"
import style0 from "./ShowTables.vue?vue&type=style&index=0&id=203f9597&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "203f9597",
  null
  
)

export default component.exports